import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { TitleBox } from '@tsinternetsale/common';

var tr = require('ts-translate-js').default.boundTR;

class NoAccountForm extends Component {

    handleOnRegisterProfile(e) {
        this.props.handleOnRegisterProfile(e)
    }

    handleOnGuestClient() {
        this.props.handleOnGuestClient();
    }

    render() {
        var guestClientButton = (this.props.displayGuestClientButton) ? 
                                <button type="button" className="btn btn-default" onClick={() => this.handleOnGuestClient()}>{tr("Continuer en tant qu'invité")}</button>
                                : null;
        
        return(
            <div className="col-xs-12 col-sm-7 col-md-6 col-lg-5">
                <TitleBox title={tr("login.noaccount") + (!this.props.isWhiteLabel ? " Reservatech.net" : "")}>
                    <div className="btn-toolbar">
                        <button type="button" className="btn btn-primary" onClick={(e) => this.handleOnRegisterProfile(e)}>{tr("login.createaccount")}</button>
                        {guestClientButton}
                    </div>
                </TitleBox>
            </div>
        );
    }
}

NoAccountForm.propTypes = {
    displayGuestClientButton: PropTypes.bool,
    handleOnRegisterProfile: PropTypes.func,
    handleOnGuestClient: PropTypes.func,
    isWhiteLabel: PropTypes.bool
}

export default NoAccountForm;
